(function () {
  function initGallery(root) {
    var main = root.querySelector('[data-main-img]');
    if (!main) return;
    root.querySelectorAll('[data-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        main.src = b.getAttribute('data-src');
        main.removeAttribute('srcset');
        main.alt = b.getAttribute('data-alt') || '';
        root.querySelectorAll('[data-thumb]').forEach(function (x) {
          x.setAttribute('aria-current', x === b ? 'true' : 'false');
        });
      });
    });
  }

  function initTiers(root) {
    var form = root.querySelector('[data-tier-form]');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var priceOut = root.querySelector('[data-cta-price]');
    function sync() {
      var c = form.querySelector('input[name="ss-tier"]:checked');
      if (!c) return;
      if (idInput) idInput.value = c.getAttribute('data-variant');
      if (priceOut) priceOut.textContent = '· ' + c.getAttribute('data-price');
      document.querySelectorAll('[data-sticky-name]').forEach(function (n) { n.textContent = c.getAttribute('data-name'); });
      document.querySelectorAll('[data-sticky-price]').forEach(function (n) { n.textContent = c.getAttribute('data-price'); });
    }
    form.addEventListener('change', sync);
    sync();
  }

  function initSticky() {
    var sticky = document.querySelector('[data-ss-sticky]');
    if (!sticky) return;
    var main = document.querySelector('[data-main-cta]');
    var fin = document.querySelector('[data-final-cta]');
    if (!('IntersectionObserver' in window) || !main) { sticky.classList.add('show'); return; }
    var past = false, atEnd = false;
    function upd() { sticky.classList.toggle('show', past && !atEnd); }
    new IntersectionObserver(function (e) {
      var r = e[0]; past = !r.isIntersecting && r.boundingClientRect.top < 0; upd();
    }).observe(main);
    if (fin) new IntersectionObserver(function (e) { atEnd = e[0].isIntersecting; upd(); }).observe(fin);
  }

  function boot() {
    document.querySelectorAll('[data-ss-product]').forEach(function (r) { initGallery(r); initTiers(r); });
    initSticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
